import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ModalProps } from "@/shared/ui/modal/Modal";
import toast from "@/domains/toasts/helpers/toast";
import useVehicles from "@/domains/estate/hooks/useVehicles";
import EstateVehiclesAddModal from "@/domains/estate/components/vehicles/EstateVehiclesAddModal";

type Props = ModalProps & { index: number };

export default function HomeMenuAddCarToGarageModalContainer({ index, ...props }: Props) {
  const { t } = useTranslation("estate");
  const { loadVehiclesRelated, vehiclesRelated, loading, updating, parkingUpdate } = useVehicles();

  useEffect(() => {
    loadVehiclesRelated();
  }, [loadVehiclesRelated]);

  return (
    <EstateVehiclesAddModal
      vehicles={vehiclesRelated}
      isLoading={loading}
      isUpdating={updating}
      {...props}
      onAdd={async (vehicle) => {
        if (vehicle.parking.type !== null) {
          toast.error(t("estate.vehicles.add.errors.VEHICLE_IS_ANOTHER_PARKING"));
          return;
        }

        await parkingUpdate(vehicle, index);
        props?.onClose();
      }}
    />
  );
}
